import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ArrowLeft, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCompany } from "@/context/CompanyContext";
import { ownerReturn } from "@/lib/api";

// Shown while the platform owner works inside a company's dashboard.
export const OwnerBanner = () => {
  const { backToAdmin } = useAuth();
  const { company } = useCompany();
  const [busy, setBusy] = useState(false);
  if (!ownerReturn.get()) return null;
  const back = async () => {
    setBusy(true);
    try { await backToAdmin(); } catch { toast.error("Could not return to the admin page"); setBusy(false); }
  };
  return (
    <div className="bg-[#0B1120] text-white" data-testid="owner-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-3 text-sm">
        <ShieldCheck className="w-4 h-4 text-[#EA580C] shrink-0" />
        <span className="min-w-0 truncate">Owner view: you&apos;re inside <b>{company?.name || "this company"}</b>. Changes you make are logged.</span>
        <button onClick={back} disabled={busy} data-testid="owner-back-btn"
          className="ml-auto shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[#EA580C] hover:bg-[#C2410C] px-3 py-1 text-xs font-bold transition-colors">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ArrowLeft className="w-3.5 h-3.5" />} Back to admin
        </button>
      </div>
    </div>
  );
};
